module.exports = __webpack_public_path__ + "img/hr-burner-mining-drill-E.026d1677.png";